import React, { useState, useRef, useEffect } from 'react';
import { Button } from '@openedx/paragon';
import { RiArrowDownSLine, RiArrowUpSLine } from '@remixicon/react';
import { useIntl } from '@edx/frontend-platform/i18n';

import messages from '../messages';

const COLLAPSED_MAX_HEIGHT = 48;

const ProgramAbout = ({ body }) => {
  const intl = useIntl();
  const [expanded, setExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    if (!contentRef.current) return;
    setIsOverflowing(contentRef.current.scrollHeight > COLLAPSED_MAX_HEIGHT);
  }, [body]);

  if (!body) return null;

  return (
    <section className="program-inner__card program-inner__about">
      <h2 className="program-inner__card-title">
        {intl.formatMessage(messages.aboutTitle)}
      </h2>
      <div className="program-inner__about-content">
        <p
          ref={contentRef}
          className={`program-inner__about-body${expanded ? ' program-inner__about-body--expanded' : ''}`}
        >
          {body}
        </p>
        {isOverflowing && !expanded && (
          <div className="program-inner__about-fade" aria-hidden />
        )}
      </div>
      {isOverflowing && (
        <Button
          variant="tertiary"
          size="sm"
          className="program-inner__about-see-more"
          iconAfter={expanded ? RiArrowUpSLine : RiArrowDownSLine}
          onClick={() => setExpanded((v) => !v)}
        >
          {expanded
            ? intl.formatMessage(messages.aboutSeeLess)
            : intl.formatMessage(messages.aboutSeeMore)}
        </Button>
      )}
    </section>
  );
};

export default ProgramAbout;
